import { defineMessage } from 'react-intl';

export const STATUS_CODE = {
  BAD_REQUEST: 400,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNAUTHORIZED: 401,
  NOT_ACCEPTABLE: 406,
};

export const GENDER_MALE = 1;
export const GENDER_FEMALE = 2;
export const GENDER_OTHER = 3;

export const GENDERS = [
  {
    value: GENDER_MALE,
    label: defineMessage({ defaultMessage: 'Male' }),
  },
  {
    value: GENDER_FEMALE,
    label: defineMessage({ defaultMessage: 'Female' }),
  },
  {
    value: GENDER_OTHER,
    label: defineMessage({ defaultMessage: 'Other' }),
  },
];
